// src/api/employeeService.js ver 01 Dec 17 2025 1:59 pm - SB118b + cleanup old commented out code
// src/api/employeeService.js ver 00
import { callCloudFunction } from './apiClient';

export const getEmployees = async (tenantid, token, page = 1, limit = 20) => {
  console.log(`EmployeeService.js TENANT_ID: ${tenantid}, token: ${token}`);
  return callCloudFunction('employeesCrud', 'GET', null, null, token,  null, {
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit }
  });
};

// export const getEmployeeById = async (tenantid, employeeId, token) => {
//   return callCloudFunction('employeesCrud', 'GET', null, employeeId, token,  null, { // ver 00a-debug
//       pathParams: { tenantid, operation: 'getById', employeeId }
//   });
// };

export const getEmployeeById = async (tenantid, id, token) => {
  return callCloudFunction('employeesCrud', 'GET', null, null, token,  null, {
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addEmployee = async (tenantid, employeeData, token) => {
  return callCloudFunction('employeesCrud', 'POST', employeeData, null, token,  null, {
      pathParams: { tenantid, operation: 'add' }
  });
};

// export const updateEmployee = async (tenantid, employeeId, employeeData, token) => {
//   return callCloudFunction('employeesCrud', 'PUT', employeeData, null, token,  null, { // ver 00a-debug
//       pathParams: { tenantid, operation: 'update', employeeId }
//   });
// };

export const updateEmployee = async (tenantid, id, employeeData, token) => {
  return callCloudFunction('employeesCrud', 'PUT', employeeData, null, token,  null, {
      pathParams: { tenantid, operation: 'update', id }
  });
};

export const getAllActiveRegularEmployeesForDropdown = async (tenantid, token) => {
    // Calls the employeesCrud 'listActvEmpNmIds' operation directly
    // return callCloudFunction('listActiveEmployeeNamesAndIds', 'GET', null, null, token, {
    return callCloudFunction('employeesCrud', 'GET', null, null, token, null,{
        pathParams: { tenantid, operation: 'listActvEmpNmIds' } // NEW: operation is part of pathParams
    });
};